import React from "react"
import Links from "./links"

export default function GoLiveWithUsGroup({ data }) {
  return (
    <div>
      <div className="bg-white rounded-[60px] px-6 md:px-10 py-8 shadow-2xl">
        <h1 className="section-h heading">{data.heading}</h1>
        <div className="md:mt-8 max-md:divide-y md:divide-x md:flex md:-mx-10 divide-zinc-700 text-dark">
          {data.cardList?.map((item, i) => {
            return (
              <div
                key={item.title + i.toString()}
                className="relative md:w-1/3 md:px-10 max-md:py-4 md:pt-6 z-[1]"
              >
                <span className="absolute inset-x-0 top-4 md:top-0 mx-auto text-[160px] lg:text-[266px] text-primary leading-[0.8] block text-center opacity-10 -z-[1] select-none">
                  {("0" + (i + 1)).slice(-2)}
                </span>
                <img
                  src={item.icon.mediaItemUrl}
                  alt="icon"
                  className="w-[60px] lg:w-[93px]"
                />
                <h2 className="mt-3 text-base font-bold !leading-none lg:text-lg lg:mt-5">
                  {item.title}
                </h2>
                <p className="mt-3 text-sm lg:mt-5">{item.excerpt}</p>
              </div>
            )
          })}
        </div>

        {data.links && (
          <div className="z-10 md:mt-8">
            <Links data={data.links} />
          </div>
        )}
      </div>
    </div>
  )
}
